import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownText = ({ text }) => {
  if (!text) return null;

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        // 1. تنسيق العناوين (بديل ###)
        h1: ({ node, ...props }) => <h1 className="text-2xl md:text-3xl font-black text-[#1B263B] dark:text-white border-b border-gray-200 dark:border-slate-700 pb-2 mb-4 mt-6" {...props} />,
        h2: ({ node, ...props }) => <h2 className="text-xl md:text-2xl font-black text-[#1B263B] dark:text-white border-b border-gray-200 dark:border-slate-700 pb-2 mb-4 mt-6" {...props} />,
        h3: ({ node, ...props }) => <h3 className="text-lg md:text-xl font-bold text-[#1B263B] dark:text-white mb-3 mt-5" {...props} />,

        // 2. تنسيق القوائم والنقاط (بديل *)
        ul: ({ node, ...props }) => <ul className="space-y-2 my-4 list-none pl-0" {...props} />,
        li: ({ node, ...props }) => (
          <li className="flex items-start gap-3" {...props}>
            <span className="text-[#C47A2C] mt-1 font-bold text-xl leading-none">•</span>
            <span className="flex-1 text-[#1B263B] dark:text-gray-200">{props.children}</span>
          </li>
        ),

        // 3. تنسيق النص العريض (بديل **)
        strong: ({ node, ...props }) => <strong className="font-bold text-[#1B263B] dark:text-white bg-[#C47A2C]/10 px-1.5 py-0.5 rounded" {...props} />,

        // 4. تنسيق الفقرات العادية عشان المسافات تظبط
        p: ({ node, ...props }) => <p className="mb-3 leading-relaxed text-[#1B263B] dark:text-gray-200" {...props} />
      }}
    >
      {text}
    </ReactMarkdown>
  );
};

export default MarkdownText;